import React from 'react'
import cx from 'classnames'

import { FormFieldError } from 'components/shared/FormFieldError/FormFieldError'
import { FormFieldHint } from 'components/shared/FormFieldHint/FormFieldHint'

import styles from './FormFieldMessage.module.scss'

type FormFieldMessageProps = {
  count?: number
  error?: React.ReactNode
  hint?: React.ReactNode
  hintVariant?: React.ComponentProps<typeof FormFieldHint>['hintVariant']
  limit?: number
}

export const FormFieldMessage = ({
  count,
  error,
  hint,
  hintVariant,
  limit,
}: FormFieldMessageProps) => {
  if (!error && !hint && !limit) {
    return null
  }

  return (
    <div className={styles.messages}>
      {hint && !error ? (
        <FormFieldHint {...{ hint, hintVariant }} />
      ) : (
        <FormFieldError {...{ error }} />
      )}
      {limit ? (
        <p
          className={cx(styles.limit, { [styles.invalid]: Boolean(error) })}
        >{`${count}/${limit}`}</p>
      ) : null}
    </div>
  )
}
